import './HeaderLoggedOut.styles.scss';

import React, { useContext } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import MyTextField from '../../common/MyTextField';
import Axios from 'axios';

import UesrContext from '../../contexts/user-context/UserProvider';
import ButtonWithLoading from '../../common/button-with-loading/ButtonWithLoading';
import FlashMessageContext from '../../contexts/flash-messages-context/FlashMessageProvider';

const loginSchema = Yup.object().shape({
	username: Yup.string().required('Required'),
	password: Yup.string().required('Required')
});

const sleep = ms => new Promise(r => setTimeout(r, ms));

const HeaderLoggedOut = () => {
	const { setCurrentUser } = useContext(UesrContext);
	const {
		setFlashMsgIsOpen,
		setFlashMsg,
		setFlashMsgDuration,
		setNotificationSeverity
	} = useContext(FlashMessageContext);
	return (
		<>
			<Formik
				initialValues={{
					username: '',
					password: ''
				}}
				onSubmit={async (values, { setSubmitting, resetForm }) => {
					await sleep(500);
					try {
						setSubmitting(true);
						const response = await Axios.post('/login', {
							...values
						});
						console.log('Loggedin user: ', response);
						if (response.status === 200 && response.data) {
							setSubmitting(false);
							resetForm();
							const currentUser = response.data;
							setCurrentUser(currentUser);
						} else if (response.status === 200 && !response.data) {
							setFlashMsgIsOpen(true);
							setFlashMsg('Incorrect Username or Password!');
							setFlashMsgDuration(4000);
							setNotificationSeverity('error');
						}
					} catch (e) {
						setFlashMsgIsOpen(true);
						setFlashMsg(e.message);
						setFlashMsgDuration(4000);
						setNotificationSeverity('error');
						console.log(e.message);
					}
				}}
				validationSchema={loginSchema}
			>
				{({ values, handleSubmit, isSubmitting, errors, touched }) => (
					<form onSubmit={handleSubmit} className="loginForm">
						<MyTextField
							name="username"
							type="text"
							variant="standard"
							placeholder="Username"
						/>
						<MyTextField
							name="password"
							type="password"
							variant="standard"
							placeholder="Password"
						/>
						<ButtonWithLoading
							isSubmitting={isSubmitting}
							errors={errors}
							btnText="Login"
							loadingMsg="LOGGING.."
						/>
					</form>
				)}
			</Formik>
		</>
	);
};

export default HeaderLoggedOut;
